import React from 'react'
import styled from 'styled-components'
import Image from 'gatsby-image'

import { desktopVw, desktopBreakpoint, mobileVw } from '../../styles'

export const ImageBlock = ({ data, reverse }) => {
  return (
    <Block reverse={reverse}>
      {data.map((image, i) =>
        i === 0 ? (
          <MainImageWrapper key={i}>
            <Image fluid={image.fluid} alt={image.title} />
          </MainImageWrapper>
        ) : null,
      )}
      <SecondaryImagesWrapper>
        {data.map((image, i) =>
          i !== 0 ? (
            <Image key={i} fluid={image.fluid} alt={image.title} />
          ) : null,
        )}
      </SecondaryImagesWrapper>
    </Block>
  )
}

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.reverse ? 'row-reverse' : ' row')};
  height: 70vw;
  .gatsby-image-wrapper {
    height: 100%;
    position: relative;
  }
  margin: ${mobileVw(8)} 0;
  @media (min-width: ${desktopBreakpoint}) {
    width: ${desktopVw(370)};
    height: auto;
    margin: 0;
  }
`

const MainImageWrapper = styled.div`
  width: 100%;
  margin: 0 ${desktopVw(5)};
`
const SecondaryImagesWrapper = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > div {
    &:last-child {
      margin-top: ${mobileVw(2)};
    }
  }
  img {
    height: 50%;
  }
  @media (min-width: ${desktopBreakpoint}) {
    > div {
      &:last-child {
        margin-top: ${desktopVw(5)};
      }
    }
  }
`

export default ImageBlock
